import apiUrl from "../../../../utils/settings";

export const getCompanyWiseInventoryDataUrl = () => {
  return apiUrl + "/user-inventory/company-wise-inventory";
};

export const getProductWiseinventoryDataUrl = () => {
  return apiUrl + "/user-inventory/paginated";
};

export const addDistributorSellInvoiceUrl = () => {
  return apiUrl + "/user-invoices/sell-product";
};

export const getUserInventoryTransactionsStpInfoUrl = () => {
  return apiUrl + "/user-inventory-transactions/ship-to-party-info";
};